import Article from "../services/article";
import BoxGenerator from "./box-generator";

export default class GridBuilder {

	constructor(html) {
		this.html = html;
		this.articleTypes = ['HOW_TO','SERVICE'];
		this.boxArticlesIds = [];
	}

	getBoxedArticleIds() {
		return this.boxArticlesIds;
	}

	async getDisplayHtmlAsync() {
		await this.generateDisplayHtml();

		return this.displayHtml;
	}

	async generateDisplayHtml() {
		try {
			//Generate regexp that matches the following placeholders:
			//<p>[[ARTICLE_TYPE]]</p>
			let placeholders = this.generateRegExpArray(this.articleTypes);

			//store the fetched article html in a variable that we will
			//alter depending on which placeholder we match.
			let html = this.html;

			//this will generate a grid if a type placeholder is found in
			//the html
			html = await this.buildTypeArticleGrid(html, placeholders);

			//this will generate a grid if random articles placeholder is
			//found in the html
			html = await this.buildRandomArticleGrid(html);

			//Save the altered html in the indexArticle and then
			//assign it to the article we pass on to the editor. (because change detection)
			this.displayHtml = html;
		} catch (error) {
			// eslint-disable-next-line
			console.error(error);
		}
	}

	async buildTypeArticleGrid(html, placeholders) {
		//Check the html for each placeholder, if a positive match is found
		//replace it with a generated grid and store it in the index article.
		for (let i = 0; i < placeholders.length; i++) {
			const p = placeholders[i];
			if (p.test(html)) {
				let typeArticles = await this.getArticlesFromType(this.articleTypes[i]);
				let resumedArticles = await this.getResumes(typeArticles);
				this.boxArticlesIds.push(...resumedArticles.map(a=>a.id));
				if (resumedArticles) {
					html = html.replace(
						p,
						this.generateGrid(resumedArticles)
					);
				}
			}
		}

		return html;
	}

	async buildRandomArticleGrid(html) {
		let linkRegexp = /<p>\[\[([^\]]+)\]\]<\/p>/;
		let regexpHasMatches = true;
		let index = 0;
		let matchedStrings = [];
		let matchedArticlesGroups = [];
		let idRegexp = /resume=([a-z0-9A-Z]+)"/;

		//replace every random article sequence with a special
		//placeholder that will be replaced with the dynamically
		//generated grid
		while (regexpHasMatches) {
			let match = linkRegexp.exec(html);
			if (match && match[1]) {
				html = html.replace(linkRegexp, `[[**${index}**]]`);
				matchedStrings.push(match[1]);
				regexpHasMatches = linkRegexp.test(html);
				index++;
			} else {
				break;
			}
		}

		//extract the resume IDs from the matched anchors between the
		//double square brackets
		matchedStrings.forEach((s) => {
			let anchorArr = s.split(";");
			let matchedArticlesIds = [];
			anchorArr.forEach((a) => {
				let match = idRegexp.exec(a);
				if (match && match[1]) {
					matchedArticlesIds.push(match[1]);
				}
			});
			matchedArticlesGroups.push(matchedArticlesIds);
		});

		for (let i = 0; i < matchedArticlesGroups.length; i++) {
			const m = matchedArticlesGroups[i];
			let resumedArticles = await this.getResumesByArray(m);
			let orderedArticles = [];
			m.forEach(id => {
				orderedArticles.push(resumedArticles.find(a => a.id == id));
				this.boxArticlesIds.push(id);
			});
			html = html.replace(`[[**${i}**]]`, this.generateGrid(orderedArticles));
		}

		return html;
	}

	generateGrid(resumedArticles) {
		if (!resumedArticles) return;

		let gridHtml = BoxGenerator.openingTag();

		resumedArticles.forEach((a) => {
			gridHtml = gridHtml + BoxGenerator.generateBox(a);
		});

		gridHtml = gridHtml + BoxGenerator.closingTag();
		return gridHtml;
	}

	generateRegExpArray(types) {
		let regExps = [];
		types.forEach((t) =>
			regExps.push(new RegExp(`<p>\\[\\[${t}\\]\\]</p>`, "g"))
		);
		return regExps;
	}

	async getArticlesFromType(type) {
		let res = await Article.instance().getArticlesMinimal(type);

		return res.data;
	}

	async getResumes(articles) {
		let ids = articles.map((a) => a.id);
		let res = await Article.instance().getListByIds(ids);

		return res.data;
	}

	async getResumesByArray(ids) {
		let res = await Article.instance().getListByIds(ids);

		return res.data;
	}

}